import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { subscribeTable } from '../lib/realtime';

export interface RestPeriodRow {
  id: string;
  driver_id: string;
  started_at: string;
  ended_at: string;
  part: 1 | 2;
  recorded_at: string;
}

/**
 * Daily rest (dygnsvila) records — manual tidbok entries plus the ≥11 h
 * digital rests the mobile app persists automatically. Live via realtime.
 */
export function useRestPeriods(driverId: string | undefined, days = 7) {
  const [rests, setRests] = useState<RestPeriodRow[]>([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!driverId) return;
    const since = new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();
    const { data } = await supabase
      .from('daily_rest_periods')
      .select('*')
      .eq('driver_id', driverId)
      .gte('ended_at', since)
      .order('ended_at', { ascending: false })
      .limit(20);
    setRests((data ?? []) as RestPeriodRow[]);
    setLoading(false);
  }, [driverId, days]);

  useEffect(() => {
    if (!driverId) { setLoading(false); return; }
    refetch();
    const unsub = subscribeTable('daily_rest_periods', refetch, `driver_id=eq.${driverId}`);
    return unsub;
  }, [driverId, refetch]);

  return { rests, loading, refetch };
}
